/*********************** Custom JS for Boost AI Search & Discovery  ************************/
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('Sorting', {
            name: 'Sorting component',
            apply: () => ({
                render(elementModel, currentRenderElement) {
                    try {
                        if (boostSDAppConfig?.generalSettings?.collection_handle == '12-days-of-fierceness') {
                            return '';
                        }
                        return currentRenderElement;
                    } catch (error) {
                        console.warn(error);
                        return currentRenderElement; // Fallback -> return the original elm if there is an error
                    }
                },
            }),
        });
        componentRegistry.useComponentPlugin('ProductPrice', {
            name: 'ProductPrice component',
            apply: () => ({
                render(elementModel, currentRenderElement) {
                    try {
                        if (boostSDAppConfig?.generalSettings?.collection_handle == '12-days-of-fierceness') {
                            return '';
                        }
                        return currentRenderElement;
                    } catch (error) {
                        console.warn(error);
                        return currentRenderElement; // Fallback -> return the original elm if there is an error
                    }
                },
            }),
        });
        componentRegistry.useComponentPlugin('ProductLabel', {
            name: 'ProductLabel component',
            apply: () => ({
                render(elementModel, currentRenderElement) {
                    try {
                        if (boostSDAppConfig?.generalSettings?.collection_handle == '12-days-of-fierceness') {
                            return '';
                        }
                        return currentRenderElement;
                    } catch (error) {
                        console.warn(error);
                        return currentRenderElement; // Fallback -> return the original elm if there is an error
                    }
                },
            }),
        });
        componentRegistry.useComponentPlugin('CTAButton', {
            name: 'CTAButton component',
            apply: () => ({
                render(elementModel, currentRenderElement) {
                    try {
                        if (boostSDAppConfig?.generalSettings?.collection_handle == '12-days-of-fierceness') {
                            return '';
                        }
                        return currentRenderElement;
                    } catch (error) {
                        console.warn(error);
                        return currentRenderElement; // Fallback -> return the original elm if there is an error
                    }
                },
            }),
        });
    }
]);